import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";

export const HorizontalBar = () => {
  return (
    <div
      style={{
        height: "5px",
        width: "40px",
        backgroundColor: "#95FF0F",
        borderRadius: "20px",
      }}
    ></div>
  );
};

export const CustomNewButton = ({ text, ...props }) => {
  return (
    <button
      style={{
        borderRadius: "6px",
        color: "#134468",
        border: "none",
        backgroundColor: "#0FFF9A",
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        padding: "18px 33px",
        fontSize: "16px",
        fontWeight: "600",
        alignItems: "center",
      }}
      {...props}
    >
      <div>{text}</div>
      <FaArrowRightLong size="24px" />
    </button>
  );
};

export const CustomNewButtonBlue = ({ text, isLoading, ...props }) => {
  return (
    <button
      disabled={isLoading ?? false}
      style={{
        borderRadius: "6px",
        color: "#fff",
        border: "none",
        backgroundColor: "#134468",
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        padding: "18px 33px",
        fontSize: "16px",
        fontWeight: "600",
        alignItems: "center",
      }}
      {...props}
    >
      <div>{isLoading === true ? "Loading...." : text}</div>
      <FaArrowRightLong size="24px" />
    </button>
  );
};

export const CustomBackButton = () => {
  return (
    <img
      src="/arrow_back_blue.svg"
      alt="back_btn"
      height="38px"
      width="38px"
      style={{
        cursor: "pointer",
      }}
    />
  );
};
